import { TvShopEntertainmentPack } from '../../../model/tv-shop-entertainment-pack';
import { EligibilityReasons } from '../../eligibility-reasons.enum';
import { OmapiIdsUtils } from '../../utils/omapi-ids/omapi-ids-utils';
import { OmapiIdConstants } from '../../omapi-id-constants';
var TvShopEntertainmentPackMapper = /** @class */ (function () {
    function TvShopEntertainmentPackMapper() {
    }
    TvShopEntertainmentPackMapper.mapEntertainmentPack = function (entertainmentPack) {
        var pack = new TvShopEntertainmentPack();
        pack.omapiId = entertainmentPack.omapiid;
        pack.isTrial = entertainmentPack.trial;
        pack.isDayPass = entertainmentPack.daypass;
        pack.futureProduct = entertainmentPack.futureactiveproduct;
        pack.downgradeUpgradeOmapiIds = entertainmentPack.downgradeomapiid;
        pack.showSubtitleInCarousel = pack.omapiId === OmapiIdConstants.STREAMZ_BASIC;
        pack.isStreamzGroup = OmapiIdsUtils.STREAMZ_PACKS_GROUP.includes(entertainmentPack.omapiid);
        pack.isSoho = entertainmentPack.isSoho;
        this.setCollectionBlock(entertainmentPack, pack);
        this.setHidden(entertainmentPack, pack);
        this.setPriceDetail(entertainmentPack, pack);
        this.setAlreadyOwnPackage(entertainmentPack, pack);
        this.setUpgrade(entertainmentPack, pack);
        this.setDowngrade(entertainmentPack, pack);
        this.setHasTrial(entertainmentPack, pack);
        this.setHasDayPass(entertainmentPack, pack);
        this.setEndDate(entertainmentPack, pack);
        return pack;
    };
    TvShopEntertainmentPackMapper.mapOptionToEntertainmentPack = function (option) {
        var pack = new TvShopEntertainmentPack();
        // @TODO: please make the options and packs have the same capitalisation for omapiid or things will go badly
        pack.omapiId = option.omapiid;
        pack.streamingOption = option.options.map(function (streamingOption) {
            return streamingOption;
        });
        pack.isStreamingBundle = OmapiIdsUtils.NETFLIX_STANDARD_BUNDLES.includes(option.omapiid);
        pack.isStreamingStandaloneProduct = OmapiIdsUtils.NETFLIX_STANDALONE_PRODUCTS.includes(option.omapiid) || option.omapiid === OmapiIdsUtils.DISNEY_PLUS_ID;
        pack.showSubtitleInCarousel = true;
        this.setPriceDetailForOption(option, pack);
        return pack;
    };
    TvShopEntertainmentPackMapper.setPriceDetail = function (entertainmentPack, pack) {
        if (entertainmentPack.priceDetail) {
            pack.priceDetail = entertainmentPack.priceDetail;
        }
    };
    TvShopEntertainmentPackMapper.setPriceDetailForOption = function (option, pack) {
        if (option.priceDetail) {
            pack.priceDetail = option.priceDetail;
        }
    };
    TvShopEntertainmentPackMapper.setDowngrade = function (entertainmentPack, pack) {
        pack.isDowngrade = !entertainmentPack.eligible && entertainmentPack.reason === EligibilityReasons.COLLECTION_BLOCK
            || entertainmentPack.eligible && entertainmentPack.reason === EligibilityReasons.DOWNGRADE;
    };
    TvShopEntertainmentPackMapper.setHidden = function (entertainmentPack, pack) {
        pack.isHidden = !entertainmentPack.eligible &&
            (entertainmentPack.reason === EligibilityReasons.NOT_SPD_LINE
                || entertainmentPack.reason === EligibilityReasons.NOT_SELLABLE
                || entertainmentPack.reason === EligibilityReasons.FORBIDDEN);
    };
    TvShopEntertainmentPackMapper.setAlreadyOwnPackage = function (entertainmentPack, pack) {
        pack.subscribed = !entertainmentPack.eligible &&
            ((entertainmentPack.reason === EligibilityReasons.PENDING_TRIAL_CONVERSION)
                || entertainmentPack.reason === EligibilityReasons.ALREADY_SUBSCRIBED);
    };
    TvShopEntertainmentPackMapper.setHasDayPass = function (entertainmentPack, pack) {
        pack.hasDayPass = entertainmentPack.reason === EligibilityReasons.HAS_DAYPASS;
    };
    TvShopEntertainmentPackMapper.setUpgrade = function (entertainmentPack, pack) {
        pack.isUpgrade = entertainmentPack.eligible && entertainmentPack.reason === EligibilityReasons.UPGRADE;
    };
    TvShopEntertainmentPackMapper.setHasTrial = function (entertainmentPack, pack) {
        pack.hasTrial = entertainmentPack.reason === EligibilityReasons.AFTER_TRIAL;
    };
    TvShopEntertainmentPackMapper.setEndDate = function (entertainmentPack, pack) {
        pack.endDate = entertainmentPack.enddate ? new Date(entertainmentPack.enddate) : undefined;
    };
    TvShopEntertainmentPackMapper.setCollectionBlock = function (entertainmentPack, pack) {
        pack.collectionBlock = !entertainmentPack.eligible && entertainmentPack.reason === EligibilityReasons.COLLECTION_BLOCK;
    };
    return TvShopEntertainmentPackMapper;
}());
export { TvShopEntertainmentPackMapper };
